import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {toastr} from "react-redux-toastr";
import * as XLSX from 'xlsx';
import { format } from 'date-fns';
import ScheduleDownloadReportComponent from "./component";

const ScheduleReportContainer = (props) => {
  const { date } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPayoutId, setSelectedPayoutId] = useState(null);
  const [showMarkSettleDialog, setShowMarkSettleDialog] = useState(false);
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedPayoutIds, setSelectedPayoutIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (location.state?.payoutReportData) {
      setReportData(location.state.payoutReportData);
      setLoading(false);
    } else {
      // navigate('/home/configuration/payoutpartners/schedule');
    }
  }, [location.state, navigate]);

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount).replace('₹', '₹ ');
  };

  const handleDownloadExcel = () => {
    try {
      const dataToExport = reportData.cohortScheduleResponseDto.map(item => ({
        'Partner ID': item.franchiseeId || 'N/A',
        'Partner Name': item.payee || 'N/A',
        'Status': item.status || 'Generated',
        'Deductions': item.deductions,
        'Payout': item.payout || 0,
        'Transfer Text': item.transferText || 'N/A'
      }));
      
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Payouts Report");
      XLSX.writeFile(wb, `payout-report-${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      toastr.error('Error', 'Failed to download report');
    }
  };

  const handleMarkSettleClick = (payoutIds) => {
    setSelectedPayoutIds(payoutIds);
    setShowMarkSettleDialog(true);
  };

  const handleMarkSettledConfirm = () => {
    if (!selectedDate) {
      toastr.error('Error', 'Please select a settlement date');
      return;
    }

    if (selectedPayoutIds.length === 0) {
      toastr.error('Error', 'Please select at least one payout to mark as settled');
      return;
    }

    const formattedDate = format(selectedDate, 'yyyy-MM-dd');
    
    props.getDataFromAPI(
      `/partner/api/v3/acc/payouts/mark-settle/?date=${reportData.date}`,
      "PATCH",
      { 
        payoutIds: selectedPayoutIds,
        settleDate: formattedDate  
      },
      (response) => {
        setShowMarkSettleDialog(false);
        setShowSuccessDialog(true);
         navigate(-1);
        toastr.success('Success', `${selectedPayoutIds.length} payout(s) marked as settled successfully`);
      },
      (err) => {
        console.error("API Error:", err);
        toastr.error("Error", err.message || "Failed to mark payout as settled");
      }
    );
  };

  const handleSuccessClose = () => {
    setShowSuccessDialog(false);
    navigate(-1);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <ScheduleDownloadReportComponent
      loading={loading}
      error={error}
      reportData={reportData}
      formatCurrency={formatCurrency}
      onDownloadExcel={handleDownloadExcel}
      onGoBack={handleGoBack}
      onMarkSettle={handleMarkSettleClick}
      showMarkSettleDialog={showMarkSettleDialog}
      setShowMarkSettleDialog={setShowMarkSettleDialog}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      onMarkSettledConfirm={handleMarkSettledConfirm}
      showSuccessDialog={showSuccessDialog}
      onSuccessClose={handleSuccessClose}
      selectedPayoutId={selectedPayoutId}
      payoutData={reportData}
      selectedPayoutIds={selectedPayoutIds}
      setSelectedPayoutIds={setSelectedPayoutIds}
      selectAll={selectAll}
      setSelectAll={setSelectAll}
    />
  );
};

const mapStateToProps = (props) => ({
  props
});

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ScheduleReportContainer);